<script lang="ts">
  export let receiveResult: any = {};

  $: presentsInfo = receiveResult?.showResult?.customData?.presentsInfo || [];
</script>

<div class="all-present-panel">
  {#each presentsInfo as p, index (index.toString())}
    <div class="present-item">
      <div class="present-title">
        {p.presentTitle}
      </div>
      <div class="present-desc">
        {p.presentDesc}
      </div>
    </div>
  {/each}
</div>

<style lang="scss">
  .all-present-panel {
    padding: 0 15px;
    .present-item {
      margin-bottom: 24px;
      .present-title {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #191919;
      }
      .present-desc {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: rgba(25, 25, 25, 0.5);
      }
    }
  }
</style>
